import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { wsmSeriesAddPath, wsmSeriesListPath, wsmSeriesPath } from "./urls";
import WsmSeriesCreateView from "./views/WsmSeriesCreate";
import WsmSeriesDetailsView from "./views/WsmSeriesDetails";
import WsmSeriesListView from "./views/WsmSeriesList";

const SeriesDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmSeriesDetailsView id={decodeURIComponent(match.params.id)} />
);

// The "add" route comes before the :id route, which would otherwise match it.
const Component = () => (
  <>
    <WindowTitle title="Product Series" />
    <Switch>
      <Route exact path={wsmSeriesAddPath} component={WsmSeriesCreateView} />
      <Route exact path={wsmSeriesListPath} component={WsmSeriesListView} />
      <Route exact path={wsmSeriesPath(":id")} component={SeriesDetails} />
    </Switch>
  </>
);

export default Component;
